<div class="full-overlay-wrapper">
	<div class="overlay-content">
		<div class="close" (click)="close()"></div>
		<div class="message">
			<div class="title">Thank you for completing the Health Assessment!</div>
			<div class="text">EHE Health team is looking forward to seeing you soon for your appointment.</div>
			<div class="image"></div>
		</div>
	</div>
</div>
